let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("3yAl4"), load("52qvO")]).then(() => parcelRequire('3rsEl'));